"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("../constants");

var _default = function _default(state) {
  return state.modules[_constants.ROUTE];
};

exports.default = _default;
module.exports = exports.default;